<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户昵称">
                <a-input v-model="queryParam.userNickName" allow-clear placeholder="请输入用户昵称" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="联系电话">
                <a-input v-model="queryParam.contactPhone" allow-clear placeholder="请输入联系电话" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="auditStatus" slot-scope="text, record">
          <a-tag v-if="record.auditStatus === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="record.auditStatus === 1" color="green">审核通过</a-tag>
          <a-tag v-else-if="record.auditStatus === 2" color="red">审核拒绝</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)"><a-icon type="eye" />详情</a>
          <a-divider type="vertical" v-if="record.auditStatus === 0" />
          <a @click="handleAudit(record)" v-if="record.auditStatus === 0"><a-icon type="check" />审核</a>
        </span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
      <audit-form ref="auditForm" @ok="getList" />
      <detail-modal ref="detailModal" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMailApply } from '@/api/cloudplant/mailApply'
import { tableMixin } from '@/store/table-mixin'
import AuditForm from './modules/AuditForm'
import DetailModal from './modules/DetailModal'

export default {
  name: 'SeedMailApply',
  mixins: [tableMixin],
  components: { AuditForm, DetailModal },
  data() {
    return {
      list: [], loading: false, pageSizeOptions: ['10', '20', '50', '100'], total: 0,
      queryParam: { userNickName: undefined, contactPhone: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '用户ID', dataIndex: 'userId', align: 'center' },
        { title: '用户昵称', dataIndex: 'userNickName', align: 'center' },
        { title: '种子名称', dataIndex: 'seedName', align: 'center' },
        { title: '气候名称', dataIndex: 'climateName', align: 'center' },
        { title: '联系电话', dataIndex: 'contactPhone', align: 'center' },
        // { title: '审核状态', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; pageMailApply(this.queryParam).then(response => { this.list = response.data.records; this.total = response.data.total; this.loading = false }) },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { userNickName: undefined, contactPhone: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() },
    handleDetail(row) { this.$refs.detailModal.show(row) },
    handleAudit(row) { this.$refs.auditForm.show(row) }
  }
}
</script>
